import { api } from './index';
import { ApiKey, CreateApiKeyRequest, CreateApiKeyResponse, DeleteApiKeyResponse } from '../types';

export const apiKeyService = {
  getApiKeys: async (): Promise<ApiKey[]> => {
    const response = await api.get<{ status: string; data: ApiKey[]; message?: string }>('/api-keys');
    if (response.data.status !== 'success') {
      throw new Error(response.data.message || 'Fehler beim Laden der API-Keys');
    }
    return response.data.data;
  },

  createApiKey: async (data: CreateApiKeyRequest): Promise<CreateApiKeyResponse> => {
    const response = await api.post<CreateApiKeyResponse>('/api-keys', {
      name: data.name,
      expiresInDays: data.expiresInDays
    });
    return response.data;
  },

  deleteApiKey: async (keyId: string): Promise<DeleteApiKeyResponse> => {
    const response = await api.delete<{ status: string; message: string }>(`/api-keys/${keyId}`);
    return {
      status: response.data.status as 'success' | 'error',
      message: response.data.message
    };
  },

  getApiKeyUsage: async (keyId: string): Promise<{ 
    status: string; 
    data: {
      totalRequests: number;
      successfulRequests: number; 
      failedRequests: number;
      lastUsed: string | null;
      dailyUsage: Array<{ date: string; requests: number }>;
      endpointUsage: Array<{ endpoint: string; count: number }>;
    }
  }> => {
    const response = await api.get(`/api-keys/${keyId}/usage`);
    return response.data;
  }
};



